import React from "react";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaHandshake, FaAward, FaLightbulb, FaUserGraduate, FaUsers, FaChild } from "react-icons/fa"; // Import Icons

const coreValues = [
  { title: "Integrity", description: "We uphold the highest ethical standards, ensuring honesty and transparency in everything we do.", icon: <FaHandshake /> },
  { title: "Excellence", description: "We strive for academic and personal excellence, encouraging students to reach their full potential.", icon: <FaAward /> },
  { title: "Innovation", description: "We embrace creative teaching methods to make learning more engaging and effective.", icon: <FaLightbulb /> },
  { title: "Empowerment", description: "We inspire students with confidence, knowledge, and skills to succeed in their future careers.", icon: <FaUserGraduate /> },
  { title: "Collaboration", description: "We foster teamwork and open communication among students, teachers, and parents.", icon: <FaUsers /> },
  { title: "Student-Centered Learning", description: "We prioritize the needs and aspirations of our students, tailoring education to their unique strengths.", icon: <FaChild /> },
];

const CoreValues = () => {
  return (
    <div className="container-fluid d-flex flex-column align-items-center justify-content-center text-white bg-black py-5 mt-5">
      {/* Section Title */}
      <motion.h1
        className="text-center fw-bold mb-5"
        style={{ color: "#FFCCCC", borderBottom: "3px solid #FFCCCC", display: "inline-block", paddingBottom: "5px" }}
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        Our Core Values
      </motion.h1>

      <div className="row w-100 justify-content-center">
        {coreValues.map((value, index) => (
          <motion.div
            key={index}
            className="col-12 col-md-6 col-lg-4 d-flex justify-content-center mb-4 px-3"
            initial={{ opacity: 0, y: 50, rotate: -3 }}
            animate={{ opacity: 1, y: 0, rotate: 0 }}
            whileHover={{ scale: 1.05, rotate: 2 }}
            transition={{ duration: 0.8, delay: index * 0.2 }}
          >
            <div
              className="card text-white p-4 shadow-lg text-center"
              style={{
                backgroundColor: "#000",
                borderRadius: "20px",
                borderStyle:"dotted",
                border: "3px solid #FFCCCC",
                maxWidth: "350px",
                boxShadow: "0 0 15px rgba(255, 204, 204, 0.5)",
              }}
            >
              <div className="mb-3" style={{ fontSize: "2rem", color: "#FFCCCC" }}>
                {value.icon}
              </div>
              <h3 className="fw-bold mb-2" style={{ color: "#FFCCCC" }}>{value.title}</h3>
              <p className="fst-italic">{value.description}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default CoreValues;
